<template>
  <div>
    <div class="header">
      <div class="left">
        <div class="logo">
          <img src="../../assets/img/logossg.png" />
        </div>
        <div class="line"></div>
        <div class="back" @click="back">返回项目列表</div>
      </div>

      <div class="company">{{ this.$route.query.projectName }}</div>
    </div>
    <el-main>
      <div class="area">
        <singleChoice
          :defaultProps="checklist"
          type="partner"
          :showDefaultData="baseInfo"
          v-if="maskshow && masktype == 'newdepartment'"
          @sub="onsub"
          @shut="onshut"
          :includeChild="true"
        ></singleChoice>
        <div class="box">
          <p class="return" @click="$router.go(-1)">返回</p>
          <span class="line">|</span>
          <p class="contract" v-if="!edit">添加协作者</p>
          <p class="contract" v-if="edit">编辑协作者</p>
        </div>
        <div class="dataitems" v-if="!edit">
          <div class="title">添加协作者</div>
          <el-form
            label-width="100px"
            ref="baseInfo"
            :rules="rules"
            :model="baseInfo"
            label-position="right"
          >
            <div class="item">
              <el-form-item label="选择协作者" prop="partner">
                <el-input
                  style="width: 450px"
                  v-model="baseInfo.partner"
                  placeholder="请选择协作者"
                  @focus="ishow"
                  suffix-icon="el-icon-arrow-down"
                />
              </el-form-item>
              <el-form-item label="手机号" prop="mobile">
                <el-input
                  disabled
                  style="width: 450px"
                  v-model="baseInfo.mobile"
                  maxlength="11"
                ></el-input>
              </el-form-item>
              <el-form-item label="邮箱" prop="email">
                <el-input
                  disabled
                  style="width: 450px"
                  v-model="baseInfo.email"
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="dataitems" v-if="edit">
          <div class="title">编辑协作者</div>
          <el-form label-width="100px" label-position="right">
            <div class="item">
              <el-form-item label="姓名：">{{ editInfo.name }}</el-form-item>
              <el-form-item label="手机号：">{{
                editInfo.mobile
              }}</el-form-item>
              <el-form-item label="邮箱：">{{ editInfo.email }}</el-form-item>
            </div>
          </el-form>
        </div>
        <div class="ibox">
          <div class="table">
            <h4 style="font-weight: bold; color: rgba(48, 49, 64, 1)">
              权限设置
            </h4>
            <div class="operating"></div>
          </div>
          <div role="tablist" aria-multiselectable="true" class="el-collapse">
            <div class="ssg_title">
              <span
                style="margin-right: 163px; color: #545566; font-weight: 600"
                >功能模块</span
              >
              <span style="color: #545566; font-weight: 600">页面查看权限</span>
              <span style="color: #545566; font-weight: 600">页面功能权限</span>
            </div>
            <!-- <permissionList  :treeData='permissionList'/> -->
            <div
              class="el-collapse-item"
              :class="{ 'is-active': item.switched }"
              v-for="(item, index) in permissionList"
              :key="index"
            >
              <div role="tab" style="position: relative">
                <div role="button" class="el-collapse-item__header">
                  <span
                    style="font-weight: 600"
                    :class="{ 'is-active': item.switched }"
                    >{{ item.name }}</span
                  >
                  <el-switch
                    class="big_switch"
                    :width="36"
                    @change="bigChange(item, index)"
                    active-color="#6669e3"
                    inactive-color="#b8b8c4"
                    v-model="item.switched"
                    :active-value="true"
                    :inactive-value="false"
                    :style="{ 'margin-left': '120px' }"
                  ></el-switch>
                  <div
                    style="
                      position: absolute;
                      top: 0;
                      right: 14px;
                      padding-right: 18px;
                    "
                    @click="open_list(index)"
                  >
                    <span
                      style="
                        font-weight: light;
                        color: #6669e3;
                        font-size: 12px;
                      "
                    >
                      {{ list_openStatus[index] ? "收起" : "展开" }}
                    </span>
                    <i
                      :class="{
                        'arrow-up': !list_openStatus[index],
                        'arrow-down': list_openStatus[index],
                      }"
                    ></i>
                  </div>
                </div>
                <div
                  class="el-collapse-item__wrap"
                  :style="{ display: item.switched ? 'block' : 'none' }"
                  v-show="list_openStatus[index]"
                >
                  <div class="el-collapse-item__content">
                     <div class="module_left_line"> 
                      <div v-for="(view, index) in item.views" :key="index">
                        <div class="module_left">
                          <div class="module_name">
                            {{ view.name }}
                            <span class="module_line"></span>
                            <span
                              class="module_last_cover"
                              v-if="item.views.length == index + 1"
                            ></span>
                          </div>
                          <div style="position: absolute; left: 184px">
                            <el-switch
                              :disabled="!item.switched"
                              class="small_switch"
                              :width="28"
                              @change="change(view)"
                              active-color="#6669e3"
                              inactive-color="#b8b8c4"
                              v-model="view.switched"
                              :active-value="true"
                              :inactive-value="false"
                            ></el-switch>
                          </div>
                          <div
                            v-if="view.funcs.length > 0"
                            style="
                              display: inline-block;
                              flex: 1;
                              margin-left: 225px;
                            "
                          >
                            <el-checkbox-group v-model="form.values">
                              <el-checkbox
                                v-for="mfunc in view.funcs"
                                :disabled="!view.switched"
                                :label="mfunc.id"
                                :key="mfunc.id"
                                style="margin-left: 0px"
                                >{{ mfunc.name }}</el-checkbox
                              >
                            </el-checkbox-group>
                          </div>
                        </div>
                        <div class="child_moudle_left_line">
                          <div
                            class="child_moudle_left"
                            v-if="view.views.length > 0"
                            v-for="(childView, index) in view.views"
                            :key="index"
                          >
                            <div class="child_moudle_name">
                              {{ childView.name }}
                              <span class="child_module_line"></span>
                              <span
                                class="child_module_last_cover"
                                v-if="view.views.length == index-1"
                              ></span>
                              <div class="child_moudle_left_line">
                                <div
                                  class="child_moudle_left"
                                  v-for="(chView, index) in childView.views"
                                  :key="index"
                                >
                                  <div class="module_name">
                                    <span
                                      style="
                                        display: inline-block;
                                        width: 90px;
                                        font-size: 12px;
                                        font-weight: bold;
                                      "
                                      >{{ chView.name }}</span
                                    >
                                    <span class="child_module_line"></span>
                                    <span
                                      class="child_module_last_cover"
                                      v-if="childView.views.length == index + 1"
                                    ></span>
                                  </div>
                                  <div style="position: absolute; left: 114px">
                                    <el-switch
                                      :disabled="!childView.switched"
                                      :width="28"
                                      class="small_switch"
                                      @change="change(chView)"
                                      active-color="#6669e3"
                                      inactive-color="#b8b8c4"
                                      v-model="chView.switched"
                                      :active-value="true"
                                      :inactive-value="false"
                                    ></el-switch>
                                  </div>
                                  <div
                                    style="
                                      position: absolute;
                                      left: 256px;
                                      display: flex;
                                    "
                                  >
                                    <el-checkbox-group v-model="form.values">
                                      <el-checkbox
                                        v-for="ifu in chView.funcs"
                                        :disabled="!chView.switched"
                                        :label="ifu.id"
                                        :key="ifu.id"
                                        style="margin-left: 0px"
                                        >{{ ifu.name }}</el-checkbox
                                      >
                                    </el-checkbox-group>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div style="position: absolute; left: 158px">
                              <el-switch
                                :width="28"
                                :disabled="!view.switched"
                                class="small_switch"
                                @change="change(childView)"
                                active-color="#6669e3"
                                inactive-color="#b8b8c4"
                                v-model="childView.switched"
                                :active-value="true"
                                :inactive-value="false"
                              ></el-switch>
                            </div>
                            <div style="position: absolute; left: 300px">
                              <el-checkbox-group v-model="form.values">
                                <el-checkbox
                                  v-for="(ifun, index) in childView.funcs"
                                  :disabled="!childView.switched"
                                  :label="ifun.id"
                                  :key="ifun.id"
                                  style="margin-left: 0px"
                                  >{{ ifun.name }}</el-checkbox
                                >
                              </el-checkbox-group>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div >
                    <div class="module_left_line">
                      <div v-for="(view, index) in item.funcs" :key="index">
                        <div class="module_left">
                          <div>
                            <span class="module_line"></span>
                            <span
                              class="module_last_cover"
                              v-if="item.funcs.length == index + 1"
                            ></span>
                          </div>
                          <div style="margin-top:-5px">
                            <el-checkbox-group v-model="form.values">
                            <el-checkbox
                              v-for="ddd in item.funcs"
                              :disabled="!item.switched"
                              :label="ddd.id"
                              :key="ddd.id"
                              style="margin-left: 0px"
                              >{{ ddd.name }}</el-checkbox
                            >
                          </el-checkbox-group>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="btndiv">
            <button class="btn" tag="button" @click="$router.go(-1)">
              取消
            </button>
            <button class="btn subbtn" v-if="!edit" @click="savePermission">
              保存
            </button>
            <button class="btn subbtn" v-if="edit" @click="setPermission">
              保存
            </button>
          </div>
        </div>
      </div>
    </el-main>
  </div>
</template>

<script>
// import axios from "../axios.js";
// import newdepartment from '../../components/common/departmentandstaff'
// import permissionList from '../systemsetPower/permissionList.vue'
import singleChoice from "../../components/common/singleChoice";
export default {
  components: {
    // permissionList,
    singleChoice,
  },
  data() {
    return {
      userId: "",
      uid: "",
      edit: false,
      form: {
        values: [],
      },
      permissionList: [],
      list_openStatus: [],
      baseInfo: {
        partner: "",
        name: "",
        mobile: "",
        email: "",
      },
      editInfo: {
        name: "",
        mobile: "",
        email: "",
      },
      rules: {
        partner: [
          {
            required: true,
            message: "请选择协作者",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入被邀请人姓名",
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "请输入邮箱",
            trigger: "blur",
          },
        ],
        range: [
          {
            required: true,
            message: "请选择活动区域",
            trigger: "change",
          },
        ],
      },
      employs: [],
      orgs: [],
      maskshow: false,
      masktype: "",
      oStatus: 1,
      checklist: {},
    };
  },
  created() {
    this.uid = this.$route.query.m;
    this.edit = this.$route.query.edit;
    if (this.edit) {
      this.loadEiditPermission();
      this.loadInfo();
    } else {
      this.loadPermissionList();
    }
  },

  watch: {
    permissionList(val) {
      for (var i = 0; i < val.length; i++) {
        this.list_openStatus.push(false);
      }
    },
  },
  methods: {
    back() {
      this.$router.push({
        path: "/ssgNewAttend",
      });
    },
    ishow() {
      this.maskshow = true;
      this.masktype = "newdepartment";
    },
    open_list(index) {
      this.list_openStatus[index] = !this.list_openStatus[index];
      this.$forceUpdate();
    },
    oneditInforange(val) {
      this.editInfo.range = val;
      this.$forceUpdate();
    },

    onemploys() {
      this.checklist = {};
      this.checklist.employee = this.employs;
      this.oStatus = 2;
      this.maskshow = true;
      this.masktype = "newdepartment";
    },

    onorgs() {
      this.checklist = {};
      this.checklist.department = this.orgs;
      console.log(this.checklist.department);
      this.oStatus = 1;
      this.maskshow = true;
      this.masktype = "newdepartment";
    },
    bigChange(item, index) {
      let checked = item.switched;
      if (checked) {
        this.list_openStatus[index] = true;
        // 一级
        this.form.values.push(item.id);
        // 二级
        item.views.forEach((ele) => {
          ele.switched = true;
          this.form.values.push(ele.id);
          // 三级
          ele.views.forEach((el) => {
            el.switched = true;
            this.form.values.push(el.id);
            // 四级
            el.views.forEach((elss) => {
              elss.switched = true;
              this.form.values.push(elss.id);
              // 五级
              elss.funcs.forEach((elvv) => {
                this.form.values.push(elvv.id);
              });
            });
            // 四级
            el.funcs.forEach((elvs) => {
              this.form.values.push(elvs.id);
            });
          });
          // 三级
          ele.funcs.forEach((elee) => {
            this.form.values.push(elee.id);
          });
        });
        // 二级
        item.funcs.forEach((els) => {
          this.form.values.push(els.id);
        });
        this.form.values = Array.from(new Set(this.form.values));
      } else {
        this.list_openStatus[index] = false;
        this.form.values.splice(
          this.form.values.findIndex((v) => v == item.id),
          1
        );
        // 一级权限
        item.switched = false;
        if (item.switched == false) {
          // 二级权限要分两种情况
          item.views.forEach((vlee) => {
            if (this.form.values.findIndex((v) => v == vlee.id) != -1) {
              this.form.values.splice(
                this.form.values.findIndex((v) => v == vlee.id),
                1
              );
              vlee.switched = false;
              // 三级权限要分两种情况
              vlee.views.forEach((vles) => {
                if (this.form.values.findIndex((v) => v == vles.id) != -1) {
                  this.form.values.splice(
                    this.form.values.findIndex((v) => v == vles.id),
                    1
                  );
                  vles.switched = false;
                  // 四级权限要分两种情况
                  vles.views.forEach((vless) => {
                    if (
                      this.form.values.findIndex((v) => v == vless.id) != -1
                    ) {
                      this.form.values.splice(
                        this.form.values.findIndex((v) => v == vless.id),
                        1
                      );
                      vless.switched = false;
                      // 五级权限
                      vless.funcs.forEach((vs) => {
                        if (
                          this.form.values.findIndex((v) => v == vs.id) != -1
                        ) {
                          this.form.values.splice(
                            this.form.values.findIndex((v) => v == vs.id),
                            1
                          );
                        }
                      });
                    }
                  });
                  // 四级权限要分两种情况
                  vles.funcs.forEach((vlessss) => {
                    if (
                      this.form.values.findIndex((v) => v == vlessss.id) != -1
                    ) {
                      this.form.values.splice(
                        this.form.values.findIndex((v) => v == vlessss.id),
                        1
                      );
                    }
                  });
                }
              });
              // 三级权限要分两种情况
              vlee.funcs.forEach((vle) => {
                if (this.form.values.findIndex((v) => v == vle.id) != -1) {
                  this.form.values.splice(
                    this.form.values.findIndex((v) => v == vle.id),
                    1
                  );
                }
              });
            }
          });

          // 二级权限要分两种情况
          item.funcs.forEach((vlee) => {
            if (this.form.values.findIndex((v) => v == vlee.id) != -1) {
              this.form.values.splice(
                this.form.values.findIndex((v) => v == vlee.id),
                1
              );
            }
          });
        }
      }
    },
    change(item) {
      let checked = item.switched;
      if (checked) {
        // 一级
        this.form.values.push(item.id);
        // 二级
        item.views.forEach((ele) => {
          ele.switched = true;
          this.form.values.push(ele.id);
          // 三级
          ele.views.forEach((el) => {
            el.switched = true;
            this.form.values.push(el.id);
            // 四级
            el.views.forEach((elss) => {
              elss.switched = true;
              this.form.values.push(elss.id);
              // 五级
              elss.funcs.forEach((elvv) => {
                this.form.values.push(elvv.id);
              });
            });
            // 四级
            el.funcs.forEach((elvs) => {
              this.form.values.push(elvs.id);
            });
          });
          // 三级
          ele.funcs.forEach((elee) => {
            this.form.values.push(elee.id);
          });
        });
        // 二级
        item.funcs.forEach((els) => {
          this.form.values.push(els.id);
        });
        this.form.values = Array.from(new Set(this.form.values));
      } else {
        this.form.values.splice(
          this.form.values.findIndex((v) => v == item.id),
          1
        );
        // 一级权限
        item.switched = false;
        if (item.switched == false) {
          // 二级权限要分两种情况
          item.views.forEach((vlee) => {
            if (this.form.values.findIndex((v) => v == vlee.id) != -1) {
              this.form.values.splice(
                this.form.values.findIndex((v) => v == vlee.id),
                1
              );
              vlee.switched = false;
              // 三级权限要分两种情况
              vlee.views.forEach((vles) => {
                if (this.form.values.findIndex((v) => v == vles.id) != -1) {
                  this.form.values.splice(
                    this.form.values.findIndex((v) => v == vles.id),
                    1
                  );
                  vles.switched = false;
                  // 四级权限要分两种情况
                  vles.views.forEach((vless) => {
                    if (
                      this.form.values.findIndex((v) => v == vless.id) != -1
                    ) {
                      this.form.values.splice(
                        this.form.values.findIndex((v) => v == vless.id),
                        1
                      );
                      vless.switched = false;
                      // 五级权限
                      vless.funcs.forEach((vs) => {
                        if (
                          this.form.values.findIndex((v) => v == vs.id) != -1
                        ) {
                          this.form.values.splice(
                            this.form.values.findIndex((v) => v == vs.id),
                            1
                          );
                        }
                      });
                    }
                  });
                  // 四级权限要分两种情况
                  vles.funcs.forEach((vlessss) => {
                    if (
                      this.form.values.findIndex((v) => v == vlessss.id) != -1
                    ) {
                      this.form.values.splice(
                        this.form.values.findIndex((v) => v == vlessss.id),
                        1
                      );
                    }
                  });
                }
              });
              // 三级权限要分两种情况
              vlee.funcs.forEach((vle) => {
                if (this.form.values.findIndex((v) => v == vle.id) != -1) {
                  this.form.values.splice(
                    this.form.values.findIndex((v) => v == vle.id),
                    1
                  );
                }
              });
            }
          });

          // 二级权限要分两种情况
          item.funcs.forEach((vlee) => {
            if (this.form.values.findIndex((v) => v == vlee.id) != -1) {
              this.form.values.splice(
                this.form.values.findIndex((v) => v == vlee.id),
                1
              );
            }
          });
        }
      }
    },
    //查询权限树
    loadPermissionList() {
      const params = {
        projectId: this.$route.query.id,
        userId: this.$route.query.userId
      };
      this.$axios.get("/eem/assist/permission/tree", { params }).then((res) => {
        if (res.data.status == 1) {
          this.permissionList = res.data.data;
          this.permissionList.forEach((ele) => {
            this.form.values.push(ele.id);
            if (ele.funcs && ele.funcs.length > 0) {
              ele.funcs.forEach((eel) => {
                this.form.values.push(eel.id);
              });
            }
            if (ele.views && ele.views.length > 0) {
              ele.views.forEach((el) => {
                this.form.values.push(el.id);
                if (el.views && el.views.length > 0) {
                  el.views.forEach((elfunc) => {
                    this.form.values.push(elfunc.id);
                    if (elfunc.views && elfunc.views.length > 0) {
                      elfunc.views.forEach((eleview) => {
                        this.form.values.push(eleview.id);
                        if (eleview.funcs && eleview.funcs.length > 0) {
                          eleview.funcs.forEach((elefun) => {
                            this.form.values.push(elefun.id);
                          });
                        }
                      });
                    }
                  });
                }
                if (el.funcs && el.funcs.length > 0) {
                  el.funcs.forEach((elfunc) => {
                    this.form.values.push(elfunc.id);
                  });
                }
                if (el.views && el.views.length > 0) {
                  el.views.forEach((el1) => {
                    this.form.values.push(el1.id);
                    if (el1.funcs && el1.funcs.length > 0) {
                      el1.funcs.forEach((elfunc) => {
                        this.form.values.push(elfunc.id);
                        if (elfunc.views && elfunc.views.length > 0) {
                          elfunc.views.forEach((elviews) => {
                            this.form.values.push(elviews.id);
                          });
                        }
                      });
                    }
                  });
                }
              });
            }
          });
          this.form.values = Array.from(new Set(this.form.values));
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    loadInfo() {
      const params = {
        projectId: this.$route.query.id,
        userId: this.$route.query.userId,
      };
      this.$axios
        .get("/eem/assist/info", {
          params,
        })
        .then((res) => {
          if (res.data.status == 1) {
            this.form.values = Array.from(new Set(res.data.data.permissionIds));
            this.editInfo = {
              mobile: res.data.data.mobile,
              name: res.data.data.name,
              email: res.data.data.email,
            };
          }
        });
    },
    loadEiditPermission() {
      const params = {
        projectId: this.$route.query.id,
        userId: this.$route.query.userId,
      };
      this.$axios
        .get("/eem/assist/permission/tree", {
          params,
        })
        .then((res) => {
          if (res.data.status == 1) {
            this.permissionList = res.data.data;
          }
        });
    },
    savePermission() {
      if (this.form.values.length == 0) {
        this.$message.warning("请选择权限");
        return;
      }
      this.$refs.baseInfo.validate((valid) => {
        if (valid) {
          let permissionLIsts = Array.from(new Set(this.form.values));
          let params = "userId=" +
                this.userId +
                "&projectId=" +
                this.$route.query.id + "&permissionIds=" + permissionLIsts;
          this.$axios
            .post(
              "/eem/assist/insert",params
            )
            .then((res) => {
              if (res.data.status == 1) {
                this.$message.success(res.data.message);
                this.$router.push({
                  path: "/ssgNewAttend/attendpermission",
                  query: {
                    id: this.$route.query.id,
                    projectName: this.$route.query.projectName,
                    userId:this.$route.query.userId
                  },
                });
              } else {
                this.$message.error(res.data.message);
              }
            });
        }
      });
    },
    setPermission() {
      if (this.form.values.length == 0) {
        this.$message.warning("请选择权限");
        return;
      }
      this.$confirm("您确定要更新权限吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let permissionLIsts = Array.from(new Set(this.form.values));
        this.$axios
          .put(
            "/eem/assist/update?userId=" +
              this.$route.query.userId +
              "&permissionIds=" +
              permissionLIsts +
              "&projectId=" +
              this.$route.query.id
          )
          .then((res) => {
            if (res.data.status == 1) {
              this.$message.success(res.data.message);
              this.$router.push({
                path: "/ssgNewAttend/attendpermission",
                query: {
                  id: this.$route.query.id,
                  projectName: this.$route.query.projectName,
                  userId:this.$route.query.userId
                },
              });
            } else {
              this.$message.error(res.data.message);
            }
          });
      });
    },
    delInvitation() {
      this.$confirm("您确定要删除该账号吗?删除后无法恢复", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        axios.put("/users/delInvitation/" + this.$route.query.m).then((res) => {
          if (res.data.status == 1) {
            this.$message.success(res.data.message);
            this.$router.push({
              path: "/setting/permission",
            });
          } else {
            this.$message.error(res.data.message);
          }
        });
      });
    },
    cancle() {
      this.$router.push({
        path: "/setting/permission",
      });
    },
    handleCheckedCitiesChange(value) {
      let checkedItems = this.form.values;
      let element = this.permissionList[value - 2];
      let childs = element.childs;
      let checkedCount = 0;
      for (let k = 0; k < childs.length; k++) {
        for (let i = 0; i < checkedItems.length; i++) {
          if (checkedItems[i] == childs[k].id) {
            checkedCount++;
          }
        }
      }
      element.checkAll = checkedCount === childs.length;
      element.isIndeterminate =
        checkedCount > 0 && checkedCount < childs.length;
    },

    onsub(val) {
      this.userId = "";
      var arr = [];
      this.checklist = {
        partner: [],
      };
      this.checklist.partner = val.partner;
      console.log(this.checklist.partner);

      for (let i = 0; i < this.checklist.partner.length; i++) {
        this.userId = this.checklist.partner[i].userId;
        this.baseInfo.partner = this.checklist.partner[i].name;
        this.baseInfo.mobile = this.checklist.partner[i].mobile;
        this.baseInfo.email = this.checklist.partner[i].email;
      }
      this.maskshow = false;
      this.masktype = "";
    },

    onshut(val) {
      this.maskshow = false;
      this.masktype = "";
      // if (this.oStatus == 1) {
      //   this.orgs = val.department;
      //   this.checklist = {};
      //   this.maskshow = false;
      //   this.masktype = "";
      // } else if (this.oStatus == 2) {
      //   this.employs = val.employee;
      //   this.checklist = {};
      //   this.maskshow = false;
      //   this.masktype = "";
      // }
    },
  },
};
</script>

<style src="../../assets/css/common/nav.less" scoped lang="less"></style>
<style src="../../assets/css/common/form.less" scoped lang="less"></style>
<style src="../../assets/css/common/details.less" scoped lang="less"></style>
<style lang="less" scoped>
.arrow-up {
  background-image: url("../../assets/img/open_list.png");
  background-repeat: round;
  display: block;
  width: 10px;
  height: 10px;
  position: absolute;
  top: 19px;
  right: 4px;
}
.arrow-down {
  background-image: url("../../assets/img/close_list.png");
  background-repeat: round;
  display: block;
  width: 10px;
  height: 10px;
  position: absolute;
  top: 19px;
  right: 4px;
}
.el-main {
  height: calc(100vh - 60px);
}
.el-form-item:first-child {
  margin-top: 22px;
}
.module_left_line {
  font-size: 12px;
  margin-left: 25px;
  border-left: 1px solid #d9dbe2;
  font-weight: bold;
}

.module_left {
  margin-left: 20px;
  display: inline-flex;
  margin-top: 20px;
  position: relative;
}

.module_name {
  width: 100px;
  position: relative;
  font-size: 12px;
  font-weight: 800;
}
.module_line {
  position: absolute;
  border-bottom: 0.5px solid #d9dbe2;
  width: 15px;
  left: -20px;
  top: 8px;
}

.child_moudle_left_line {
  border-left: 1px solid #d9dbe2;
  margin-left: 29px;
  display: flex;
  flex-direction: column;
}

.child_moudle_left {
  display: inline-flex;
  margin-left: 15px;
  margin-top: 20px;
  position: relative;
}

.child_moudle_name {
  width: 52px;
  position: relative;
}

.child_module_line {
  position: absolute;
  border-bottom: 0.5px solid #d9dbe2;
  width: 15px;
  left: -15px;
  top: 8px;
}

.module_last_cover {
  width: 10px;
  height: 10000px;
  display: block;
  position: absolute;
  left: -30px;
  top: 9px;
  background: white;
}

.child_module_last_cover {
  display: block;
  height: 10000px;
  width: 10px;
  position: absolute;
  left: -20px;
  top: 9px;
  background: white;
}

.ssg_title {
  padding-left: 20px;
  margin-bottom: 10px;

  span {
    font-size: 12px;
    font-weight: bold;
    color: rgba(84, 85, 102, 1);
  }
}

.ssg_title span {
  margin-right: 66px;
}

/deep/.el-checkbox__label {
  font-size: 12px;
  font-weight: bold;
  padding-left: 5px;
}

.el-checkbox-group {
  display: contents;
}

.el-checkbox-group label {
  /* margin-left: 10px; */
  margin-right: 16px;
  // width: 120px;
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #6669e3;
  border-color: #6669e3;
}

.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #606266;
}

.el-icon-arrow-right:before {
  content: "\E604";
  color: white;
}

.el-collapse {
  border: 0;
}

.el-collapse-item__header {
  // width:90px;
  color: #303140;
  font-size: 14px;
  font-weight: bold;
  padding-left: 20px;
  border: 0;
  // position: relative;
}
.el-collapse-item__header span {
  width: 90px;
}

.el-carousel__mask,
.el-cascader-menu,
.el-cascader-menu__item.is-disabled:hover,
.el-collapse-item__header {
  background-color: rgb(248, 250, 251);
}

.el-carousel__mask,
.el-cascader-menu,
.el-cascader-menu__item.is-disabled:hover,
.el-collapse-item__header,
.el-collapse-item__wrap {
  background-color: whtie;
}

.el-collapse-item {
  margin-bottom: 15px;
  border: 1px solid #b2b5ef;
}

.el-collapse-item.is-active {
  border: 1px solid #b2b5ef;
}

.el-collapse-item:last-child {
  margin-bottom: 10px;
}

.el-switch__label--left {
  margin-right: 0;
}

.el-switch__label--right {
  margin-left: 0;
}

.el-switch__label.is-active {
  color: #fff;
}

.el-switch__label {
  color: #fff;
}
/deep/.big_switch {
  height: 20px !important;
  line-height: 20px !important;
  .el-switch__core {
    height: 20px !important;
    border-radius: 10px !important;
  }
  .el-switch__core:after {
    width: 16px !important;
    height: 16px !important;
    line-height: 16px !important;
  }
}
/deep/.big_switch.is-checked .el-switch__core::after {
    margin-left: -18px !important;
  }
  /deep/.small_switch.is-checked .el-switch__core::after {
    margin-left: -14px !important;
  }
/deep/.small_switch {
  height: 16px !important;
  line-height: 16px !important;
  .el-switch__core {
    height: 16px !important;
    border-radius: 10px !important;
  }
  .el-switch__core:after {
    width: 12px !important;
    height: 12px !important;
    line-height: 12px !important;
  }
}

/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #545566;
  font-size: 12px;
}
.el-switch__label * {
  font-size: 12px;
}

// 	.custombtn {
// 		position: absolute;
// 		top: 10px;
// 		right: 10px;
// 	}

.dataitems {
  .title {
    font-size: 24px;
    line-height: 24px;
    font-weight: bold;
    color: #303140;
    margin: 31px 0 32px;
  }
}

.group {
  margin-bottom: 20px;
  background-color: #f2f5f8;
  padding-top: 10px;
  padding-bottom: 20px;
  border-radius: 10px;
  width: 70%;
  margin-left: 15%;
}

.menu {
  margin-bottom: 10px;
  border-bottom: 1px solid #dadee2;
  padding-left: 20px;
  padding-bottom: 10px;
}
.customize {
  width: 100%;
  margin-bottom: 20px;
  .item {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding-left: 100px;
    box-sizing: border-box;
    .title {
      min-width: 100px;
      font-size: 14px;
    }

    .btn {
      min-width: 120px;
      padding: 0 8px;
    }

    .statistics {
      font-size: 14px;
      color: #6668e3;
      margin-left: 20px;
    }
  }
  .blockdiv {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    span {
      font-size: 14px;
      margin: 0 10px 0 16px;
    }
    div {
      padding: 2px 8px;
      background-color: rgb(136, 136, 136);
      font-size: 12px;
      margin-right: 8px;
      border-radius: 4px;
      color: #fff;
      margin-top: 10px;
      i {
        cursor: pointer;
      }
    }
  }
}
.header {
  height: 63px;
  background-color: #f2f5f8;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;

  .left {
    display: flex;
    align-items: center;
  }
  .company {
    font-size: 14px;
    font-weight: 400;
    color: rgba(48, 49, 64, 1);
    margin-right: 30px;
  }
  .line {
    width: 1px;
    height: 21px;
    background-color: #d9dbe2;
    margin: 0 37px;
  }
  .back {
    font-size: 12px;
    font-weight: 400;
    color: #6669e3;
    cursor: pointer;
  }
  .logo {
    margin-left: 30px;
  }
}
.box {
  display: flex;
  // align-items: center;
  .return {
    font-size: 12px;
    line-height: 12px;
    font-weight: 400;
    color: #6669e3;
    margin-right: 8px;
    cursor: pointer;
  }

  .line {
    width: 1px;
    height: 12px;
    line-height: 12px;
    margin-right: 7px;
    color: #d8dbe2;
  }

  .lines {
    margin-right: 20px;
    color: #606266;
    font-weight: bold;
  }

  .back:hover {
    color: #6669e3;
    cursor: pointer;
  }

  .contract {
    line-height: 12px;
    font-size: 12px;
    font-weight: 400;
    color: #8a8a9a;
  }
}
</style>
